import styled from "styled-components";

const ArrowButton = styled.button`
  background-color: white;
  cursor: pointer;
  box-shadow: rgba(8, 11, 14, 0.06) 0px 0px 1px 0px, rgba(8, 11, 14, 0.1) 0px 32px 40px -1px;
  padding: .5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export default ArrowButton;
